{
  "aurora-ribbon": [0.4219, 0.4453, 0.5781, 0.5313],
  "aws-baseball-cap-blue": [0.3281, 0.0313, 0.6719, 0.2891],
  "aws-baseball-cap-gold": [0.3125, 0.0625, 0.6797, 0.3281],
  "aws-baseball-cap-green": [0.3281, 0.0313, 0.6719, 0.2891],
  "aws-baseball-cap-orange": [0.3281, 0.0313, 0.6719, 0.2891],
  "aws-baseball-cap-purple": [0.3281, 0.0313, 0.6719, 0.2891],
  "aws-baseball-cap-red": [0.3281, 0.0313, 0.6719, 0.2891],
  "aws-baseball-cap-silver": [0.3125, 0.0859, 0.6875, 0.3281],
  "aws-baseball-cap-sparkly": [0.3125, 0.0313, 0.6875, 0.2891],
  "aws-baseball-cap-white": [0.3281, 0.0313, 0.6719, 0.2891],
  "aws-baseball-cap-yellow": [0.3281, 0.0313, 0.6719, 0.2891],
  "aws-hoodie-blue": [0.2891, 0.4375, 0.7188, 0.7188],
  "aws-hoodie-gold": [0.2813, 0.4375, 0.7188, 0.7266],
  "aws-hoodie-green": [0.2891, 0.4375, 0.7188, 0.7188],
  "aws-hoodie-orange": [0.2891, 0.4375, 0.7188, 0.7188],
  "aws-hoodie-purple": [0.2891, 0.4375, 0.7188, 0.7188],
  "aws-hoodie-red": [0.2891, 0.4375, 0.7188, 0.7188],
  "aws-hoodie-silver": [0.2891, 0.4297, 0.7109, 0.7344],
  "aws-hoodie-sparkly": [0.2891, 0.4219, 0.7109, 0.7188],
  "aws-hoodie-white": [0.2891, 0.4375, 0.7188, 0.7188],
  "aws-hoodie-yellow": [0.2891, 0.4375, 0.7188, 0.7188],
  "aws-jean-shorts-blue": [0.3516, 0.5938, 0.6406, 0.75],
  "aws-jeans-blue": [0.3672, 0.6016, 0.6328, 0.8438],
  "aws-pants-blue": [0.3828, 0.6094, 0.6172, 0.8203],
  "aws-pants-gold": [0.3828, 0.6406, 0.6172, 0.8281],
  "aws-pants-green": [0.3828, 0.6094, 0.6172, 0.8203],
  "aws-pants-orange": [0.3828, 0.6094, 0.6172, 0.8203],
  "aws-pants-purple": [0.3828, 0.6094, 0.6172, 0.8203],
  "aws-pants-red": [0.3828, 0.6094, 0.6172, 0.8203],
  "aws-pants-silver": [0.375, 0.6094, 0.6172, 0.8281],
  "aws-pants-sparkly": [0.3828, 0.5938, 0.625, 0.8359],
  "aws-pants-white": [0.3828, 0.6094, 0.6172, 0.8203],
  "aws-pants-yellow": [0.3828, 0.6094, 0.6172, 0.8203],
  "aws-tshirt-blue": [0.3125, 0.4453, 0.6875, 0.7266],
  "aws-tshirt-gold": [0.3203, 0.4531, 0.6797, 0.7266],
  "aws-tshirt-green": [0.3125, 0.4453, 0.6875, 0.7266],
  "aws-tshirt-orange": [0.3125, 0.4453, 0.6875, 0.7266],
  "aws-tshirt-purple": [0.3125, 0.4453, 0.6875, 0.7266],
  "aws-tshirt-red": [0.3125, 0.4453, 0.6875, 0.7266],
  "aws-tshirt-silver": [0.3047, 0.4453, 0.6953, 0.7266],
  "aws-tshirt-sparkly": [0.3125, 0.4453, 0.6875, 0.7344],
  "aws-tshirt-white": [0.3125, 0.4453, 0.6875, 0.7266],
  "aws-tshirt-yellow": [0.3125, 0.4453, 0.6875, 0.7266],
  "backwards-clock-hand": [0.4297, 0.5078, 0.5703, 0.6641],
  "bakery-window-warmth": [0.2813, 0.4375, 0.7188, 0.7344],
  "balloon-ribbon": [0.6172, 0.0469, 0.9063, 0.7109],
  "bottled-birdsong": [0.75, 0.1719, 0.9922, 0.3906],
  "bottled-sunrise": [0.3125, 0.2266, 0.6719, 0.3906],
  "bottled-thunderclap": [0.6719, 0.3359, 0.8438, 0.7578],
  "bouncing-breadcrumb": [0.2969, 0.7344, 0.7031, 0.8906],
  "bubble-carousel": [0.3281, 0.0156, 0.6953, 0.2891],
  "bubble-pop-echo": [0.6484, 0.3672, 0.8594, 0.6875],
  "bumblebee-hum": [0.7031, 0.0703, 0.9297, 0.2734],
  "bus-stop-breeze": [0.3672, 0.4219, 0.6328, 0.6328],
  "cartographers-living-atlas": [0.2891, 0.4297, 0.7031, 0.8125],
  "cat-nap-sunspot": [0.7031, 0.1484, 0.9453, 0.4688],
  "chatty-compass": [0.4219, 0.5156, 0.5703, 0.6563],
  "clock-at-worlds-heart": [0.3125, 0.4297, 0.6875, 0.7344],
  "clockwork-hummingbird": [0.6328, 0.0859, 0.9844, 0.3828],
  "cloud-hopper-boots": [0.3359, 0.7422, 0.6641, 0.875],
  "coffee-cup-cloud": [0.7188, 0.1484, 0.9297, 0.3203],
  "comet-marble": [0.4922, 0.2266, 0.6797, 0.4063],
  "counting-sheep-cloud": [0.6875, 0.0703, 0.9531, 0.3516],
  "crosswalk-chirp": [0.3672, 0.4453, 0.6328, 0.6953],
  "crown-of-seasons": [0.3516, 0, 0.6719, 0.2422],
  "crumb-of-sunshine": [0.3125, 0.0625, 0.6797, 0.2969],
  "curbside-clover": [0.5391, 0.3281, 0.6328, 0.4219],
  "dandelion-wish": [0.3047, 0.1094, 0.6875, 0.2656],
  "daydream-telescope": [0.2031, 0.3984, 0.3828, 0.7344],
  "doorbell-ding": [0.3828, 0.4375, 0.6172, 0.6953],
  "drumming-drainpipe": [0.6719, 0.3203, 0.875, 0.5313],
  "echo-in-a-jar": [0.125, 0.4922, 0.3516, 0.7422],
  "endless-spinning-top": [0.3125, 0.0156, 0.6875, 0.3047],
  "ethrling-queens-marble": [0.1953, 0.3672, 0.3516, 0.7031],
  "ever-blooming-bouquet": [0.5469, 0.3438, 0.8359, 0.7031],
  "firefly-choir-jar": [0.2109, 0.5313, 0.3672, 0.8281],
  "firefly-freckle": [0.3438, 0.2578, 0.6563, 0.3438],
  "first-lantern-of-dusk": [0.7031, 0.0938, 0.9375, 0.3281],
  "floating-lily-lamp": [0.3203, 0.0469, 0.6563, 0.2656],
  "fountain-coin-wink": [0.4844, 0.2266, 0.6953, 0.4141],
  "garden-of-small-suns": [0.2422, 0, 0.7578, 0.2813],
  "gearwork-snail": [0.7266, 0.1094, 0.9453, 0.3359],
  "giggle-catcher-hoop": [0.4453, 0.4844, 0.5469, 0.6328],
  "giggling-pebble": [0.375, 0.4453, 0.6328, 0.8203],
  "glimmerwing-lantern": [0.6484, 0.5547, 0.8438, 0.8828],
  "glow-in-the-day-star": [0.3438, 0.0469, 0.6094, 0.2969],
  "gravity-shy-feather": [0.3438, 0.0078, 0.7969, 0.2578],
  "gumdrop-pebble": [0.3828, 0.4375, 0.6172, 0.5625],
  "heart-of-the-ethr": [0.4141, 0.4609, 0.5859, 0.6484],
  "hiccup-firefly": [0.7188, 0.1563, 0.8828, 0.3828],
  "hopscotch-pebble": [0.3125, 0.7656, 0.6875, 0.8828],
  "humming-teaspoon": [0.2891, 0.0078, 0.7109, 0.2891],
  "inside-out-umbrella": [0.4375, 0.0156, 1, 0.6016],
  "jumping-jellybean": [0.3594, 0.7188, 0.6484, 0.9141],
  "lamp-post-glow": [0.6094, 0.2578, 0.8203, 0.7031],
  "leaf-boat": [0.3516, 0.7891, 0.6406, 0.9063],
  "library-whisper": [0.3203, 0.2422, 0.6719, 0.375],
  "lighthouse-in-a-bottle": [0.4531, 0.5313, 0.5469, 0.6641],
  "lost-coat-button": [0.3984, 0.4219, 0.5938, 0.6563],
  "melody-lock-key": [0.4219, 0.4531, 0.5781, 0.6875],
  "meteor-hatchling-egg": [0.7188, 0.1016, 0.9688, 0.3125],
  "midnight-carousel-horse": [0.6953, 0.1328, 0.9609, 0.4375],
  "midnight-sundial": [0.2109, 0.0313, 0.7891, 0.3281],
  "mirror-of-kind-words": [0.3516, 0.2266, 0.6797, 0.5938],
  "mirror-puddle": [0.3516, 0.1328, 0.6406, 0.4609],
  "morning-marble": [0.2813, 0.4453, 0.7109, 0.8359],
  "moss-pillow": [0.3203, 0.7656, 0.6875, 0.8906],
  "mushroom-umbrella": [0.2656, 0.0469, 0.7266, 0.3047],
  "paper-crane-messenger": [0.6875, 0.0625, 0.9453, 0.25],
  "pencil-stub-doodle": [0.3203, 0.4531, 0.6797, 0.7109],
  "picnic-ant-parade": [0.7109, 0.0859, 0.9453, 0.4375],
  "pocket-puddle": [0.3125, 0.2266, 0.6875, 0.3594],
  "pocket-rainbow-prism": [0.3125, 0.2344, 0.6797, 0.375],
  "pocket-weather-globe": [0.3047, 0.125, 0.6875, 0.5547],
  "pocketful-of-fog": [0.2969, 0.4297, 0.7031, 0.7344],
  "polite-thundercloud": [0.6016, 0.0625, 0.9609, 0.2656],
  "postcard-corner": [0.4141, 0.4297, 0.5859, 0.6719],
  "puddle-fish": [0.7109, 0.1563, 0.9609, 0.3672],
  "puddle-jumper-sock": [0.3594, 0.7344, 0.6406, 0.875],
  "rainbow-paint-pot": [0.2891, 0.4141, 0.7109, 0.7578],
  "rainbow-root-seed": [0.3359, 0.7969, 0.6563, 0.9219],
  "rainmaker-teapot": [0.7188, 0.0859, 0.9688, 0.2891],
  "reverse-raindrop": [0.2813, 0.4219, 0.7188, 0.7656],
  "rubber-duck-echo": [0.7266, 0.1641, 0.9453, 0.4141],
  "seashell-murmur": [0.3984, 0.4375, 0.6094, 0.5703],
  "shadow-puppet-bunny": [0.7422, 0.0859, 0.8828, 0.3594],
  "shoelace-squiggle": [0.3047, 0.7578, 0.7031, 0.8906],
  "sidewalk-chalk-spark": [0.3281, 0.7344, 0.6719, 0.8984],
  "singing-fountain-pen": [0.2109, 0.3516, 0.4453, 0.6875],
  "sky-whale-calf": [0.7109, 0.0938, 0.9922, 0.3047],
  "sleepwalking-slipper": [0.3203, 0.75, 0.6797, 0.8906],
  "snail-trail-sparkle": [0.7109, 0.1719, 0.9297, 0.4297],
  "sneezing-snow-globe": [0.25, 0.0938, 0.7031, 0.5391],
  "snoozy-acorn": [0.3047, 0.0547, 0.6875, 0.2891],
  "snowflake-locket": [0.3906, 0.4375, 0.6094, 0.6641],
  "star-whales-song": [0.3125, 0.2031, 0.6875, 0.3672],
  "starlit-rain-umbrella": [0.0078, 0, 0.625, 0.5859],
  "sticky-note-sprite": [0.2188, 0.4375, 0.7656, 0.8047],
  "stillness-pocketwatch": [0.4063, 0.4375, 0.5938, 0.7031],
  "storm-herders-bell": [0.1641, 0.2969, 0.4141, 0.6719],
  "street-sign-shimmer": [0.1875, 0.2578, 0.3828, 0.7188],
  "sunflower-seed-smile": [0.2656, 0.0469, 0.7344, 0.2813],
  "teacup-ripple": [0.2891, 0.4453, 0.7109, 0.7109],
  "teleporting-thimble": [0.5938, 0.2734, 0.8516, 0.6328],
  "thumbnail-lighthouse": [0.6641, 0.2109, 0.7969, 0.5469],
  "ticket-stub-thrill": [0.3594, 0, 0.6328, 0.1797],
  "ticklish-doorknob": [0.4141, 0.4531, 0.5859, 0.6094],
  "tidecaller-conch": [0.2422, 0.375, 0.4453, 0.6875],
  "twig-wand": [0.125, 0.3281, 0.3906, 0.6875],
  "umbrella-drip": [0.3047, 0, 0.9844, 0.6406],
  "wandering-door-knocker": [0.3672, 0.4375, 0.6328, 0.7344],
  "weather-vane-rooster": [0.7031, 0.1172, 0.8984, 0.3828],
  "whispering-seashell-horn": [0.4609, 0.5078, 0.5469, 0.6563],
  "whistling-keyhole": [0.3672, 0.4453, 0.625, 0.7266],
  "window-frost-doodle": [0.3047, 0.2422, 0.6875, 0.3906],
  "wishing-well-bucket": [0.3047, 0.0313, 0.6875, 0.3281],
  "wobbly-spoon": [0.2266, 0.3672, 0.3594, 0.7031]
}
